import * as React from 'react';
import ICompaniesList, { TCompaniesList } from './ICompaniesList';
import CompaniesListData from '@appComponents/CompaniesListData/CompaniesListData';

import * as app from '@company/AppStyle.module.scss';
import Loader from '@appComponents/Loader/Loader';

import * as style from './CompaniesListStyle.module.scss'

export default class CompaniesList extends React.Component<ICompaniesList, TCompaniesList> {
  timeout: number | undefined = undefined;

  state: TCompaniesList = {
    search: this.props.query,
    inputFocus: false,
    companiesList: [],
    total: 0,
    dataLoaded: false,
  };

  handleChange = (event:React.ChangeEvent<HTMLInputElement>) => {
    clearTimeout(this.timeout);

    const search = event.target.value;
    this.setState({ search });

    this.timeout = window.setTimeout(() => {
      this.props.updateQuery(1, search);
    }, 500);
  }

  handleFocus = (inputFocus: boolean) => {
    this.setState({ inputFocus });
  }

  UNSAFE_componentWillReceiveProps(nextProps:ICompaniesList) {
    const { companiesData } = nextProps;
    if (this.props.companiesData.items !== nextProps.companiesData.items) {
      this.setState({ companiesList: companiesData.items, total: companiesData.total_count, dataLoaded: true });
    }
  }

  render() {
    const { handleChange, handleFocus } = this;
    const { search, inputFocus, companiesList, total, dataLoaded } = this.state;
    return (
      <React.Fragment>
        <div className={[style.companiesList, style.companiesListSearch].join(' ')}>
          <div className={[style.searchContainer,inputFocus ? style.focus : ''].join(' ')}>
            <input
              placeholder="Find Companies"
              className={style.searchInput}
              type="text"
              value={search}
              onChange={e => handleChange(e)}
              onFocus={() => handleFocus(true)}
              onBlur={() => handleFocus(false)}
            />
          </div>
          <div className={[app.clearfix, style.companiesCountContainer].join(' ')}>
            <div className={style.companiesCount}>
              {
                companiesList.length > 0 ?
                  `${total} Companies` : ''
              }
            </div>
          </div>
        </div>
        <div className={style.companiesList}>
          <CompaniesListData companiesList={companiesList} connectedToRouter={true}/>
          {
            !dataLoaded &&
              <Loader/>
          }
          {
            companiesList.length === 0 &&
            dataLoaded &&
            search.length > 0 &&
            <h1 className={style.noResults}>
              No results for <strong>{search}</strong>
              <br/>
              <small>please type other phrase</small>
            </h1>
          }
          {
            companiesList.length === 0 &&
            dataLoaded &&
            search.length === 0 &&
            <h1 className={style.noResults}>
              No results
              <br/>
              <small>please change filters</small>
            </h1>
          }
        </div>
      </React.Fragment>
    );
  }
}
